import { SuperModel } from './super-model.model';

export class RequestCoupon extends SuperModel {
  userFirstName: string;
  userLastName: string;

  constructor(data: Partial<RequestCoupon> = {}) {
    super(data);
  }

  get serialised() {
    return {
      userFirstName: this.userFirstName,
      userLastName: this.userLastName,
    };
  }
}
